import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import Divider from "@elements/Divider/Divider";
import Heading from "@elements/Typography/Heading";
import { isArrayWithElements } from "@helper/utils";
import { TLFHomeWidgetProps } from "@typings/PagePayloadType";
import { ReactElement } from "react";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export default function TLFHomeWidget({
  recordedVideo,
  topStories,
}: TLFHomeWidgetProps): ReactElement {
  const title = "தமிழ்மொழி விழா 2026";

  const articleStyle = `w-full ${recordedVideo ? "lg:w-full" : "lg:w-1/2"} xl:w-1/2 order-last`;

  return (
    <div className="flex flex-col gap-xs bg-gray-500 mb-5 xl:mx-[-95px] xl:px-0 xl:w-[100%+190px]">
      <div className="w-full h-2.5 bg-gradient-to-r from-pink-701 to-pink-301 xl:mb-5"></div>
      <div className="xl:max-w-xl w-full mx-auto xxs:px-sm xl:p-0 max-xsm:px-1 mb-10">
        <div className="">
          <div className="mb-5 md:mb-2.5">
            <Heading
              Element="h1"
              className={twMerge(
                "inline font-bold font-primary text-sm lg:text-2.5md leading-9 mb-5",
              )}
            >
              {title}
            </Heading>
            <div className="ml-2.5 md:pl-12 inline float-right mt-2 md:mt-4">
              <Link
                reloadDocument
                to={`/keywords/tamil-language-festival-2026?ref=tlf-home`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-200 font-bold text-base lg:text-sm leading-6"
              >
                மேலும் படிக்க
                <img
                  alt="toggle-button-chevie"
                  height={28}
                  width={28}
                  className="pl-[5px] inline"
                  src={ChevronImage}
                />
              </Link>
            </div>
          </div>
          <Divider className="border-b border-gray-2200 mb-5" />
        </div>

        <div className="flex flex-wrap">
          {recordedVideo && (
            <div className="w-full xl:w-1/2 lg:w-2/3 xl:pr-5 ge-youtube-video-home mb-380 xl:mb-0 order-first lg:order-second">
              <div dangerouslySetInnerHTML={{ __html: recordedVideo }} />
            </div>
          )}
          <div className={articleStyle}>
            {isArrayWithElements(topStories) ? (
              <>
                <div className="text-sm font-medium font-secondary leading-6 pb-2.5">
                  செய்திகள்
                </div>
                {topStories.map((article, i, row) => (
                  <ArticleCard
                    displayWidth={135}
                    displayHeight={90}
                    key={article.id}
                    elements={{ hasParagraph: false, hasDate: true }}
                    overrideStyle={{
                      cardWrapper: twMerge(
                        "flex-row",
                        i + 1 === row.length
                          ? "border-b-0 pb-0"
                          : "border-b-gray-2050",
                        i === 0 && "pt-0",
                      ),
                      titleStyle:
                        "font-semibold font-primary text-2sm text-gray-100 hover:text-gray-100",
                      imageWrapperStyle: "hidden",
                      contentWrapper: "gap-xs",
                      titleWrapper: "gap-0",
                      imageStyle: "w-full h-23",
                    }}
                    refMedium="home_tlf_top_stories"
                    {...article}
                  />
                ))}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
